export { default } from 'features/account/routes/account-orders-route';
